export const vizConfig = {
    colors: {
        baseline: '#52b3d9',
        canary: '#e26a6a',
        background: '#f8f8f8',
    },
    height: 400,
    timeSeries: {
        minimapDataPointsThreshold: 240,
        minimapHeight: 40,
        axisTickLineHeight: 4,
        axisTickLabelHeight: 32,
        axisLabelHeight: 16,
    },
    dataGroupMap: {
        baseline: 'control',
        canary: 'experiment',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2theWVudGEvcmVwb3J0L2RldGFpbC9ncmFwaC9zZW1pb3RpYy9jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJBLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBZTtJQUNuQyxNQUFNLEVBQUU7UUFDTixRQUFRLEVBQUUsU0FBUztRQUNuQixNQUFNLEVBQUUsU0FBUztRQUNqQixVQUFVLEVBQUUsU0FBUztLQUN0QjtJQUNELE1BQU0sRUFBRSxHQUFHO0lBQ1gsVUFBVSxFQUFFO1FBQ1YsMEJBQTBCLEVBQUUsR0FBRztRQUMvQixhQUFhLEVBQUUsRUFBRTtRQUNqQixrQkFBa0IsRUFBRSxDQUFDO1FBQ3JCLG1CQUFtQixFQUFFLEVBQUU7UUFDdkIsZUFBZSxFQUFFLEVBQUU7S0FDcEI7SUFDRCxZQUFZLEVBQUU7UUFDWixRQUFRLEVBQUUsU0FBUztRQUNuQixNQUFNLEVBQUUsWUFBWTtLQUNyQjtDQUNGLENBQUMifQ==